<template>
  <div>
    <invitation v-if="inviteConfig.inviteEnable"/>
    <section class="users_list">
      <search-user/>
      <favorite-users/>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Invitation from '@/components/home/users/Invitation';
import SearchUser from '@/components/home/users/SearchUser';
import FavoriteUsers from '@/components/home/users/FavoriteUserList';

export default {
  name: 'favorite_users-screen',
  provide: {
    isModal: false,
  },
  components: { Invitation, SearchUser, FavoriteUsers },
  computed: {
    ...mapState('common', [
      'inviteConfig',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/FavoriteUsersScreen.vue